import s from"react";import{cnJoin as e}from"../../utils/cssUtils/cssUtils.js";const t=({children:t,className:r})=>s.createElement("div",{className:e("rounded-md",r)},t);export{t as default};
